export default __webpack_public_path__ + "static/media/bg.4a01801b.jpg";